/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import PopupRadio from "vux/src/components/popup-radio/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import XAddress from "vux/src/components/x-address/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import SelectCustomer from '@/pages/home/appointment/SelectCustomer.vue';
import ImgUpload from '@/components/ImgUpload';
import FileUpload from '@/components/FileUpload';
import Dispatch from './Dispatch';
import AddressList from './AddressList';
import Product from './product';
import { sendrevisedordersave, getSendRevisedOrderSendBaseInfo, apisystemsettingByCode, getV2SendRevisedOrderTmplFields } from '@/api';
import SinglePicker from '@/components/Base/SinglePicker';
import CustomFormList from '@/components/CustomFormList';
export default {
  name: 'Appointment',
  components: {
    CustomFormList: CustomFormList,
    SinglePicker: SinglePicker,
    SelectCustomer: SelectCustomer,
    XInput: XInput,
    XButton: XButton,
    Group: Group,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    PopupRadio: PopupRadio,
    Datetime: Datetime,
    XSwitch: XSwitch,
    XAddress: XAddress,
    Checklist: Checklist,
    XTextarea: XTextarea,
    Cell: Cell,
    CellBox: CellBox,
    ImgUpload: ImgUpload,
    FileUpload: FileUpload,
    Dispatch: Dispatch,
    AddressList: AddressList,
    Product: Product
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    id: [String, Number],
    formData: {
      type: Object
    },
    productId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      fieldData: [],
      fieldList: [],
      isShowCustomerInput: 0,
      customerList: [],
      isShowSelectCustomer: false,
      custom_name: '',
      isShowProduct: false,
      SendMessage: {
        fk_t_customer_id: '',
        descri: '',
        imgUrl: [],
        fileUrl: [],
        serviceGroupId: '',
        serviceGroupName: '',
        revised_addr: '',
        revised_linkman: '',
        revised_linkman_phone: '',
        gpsAddr: '',
        detailAddr: '',
        customerPro: []
      },
      dispatchShow: false,
      isAddressListShow: false,
      btnLoading: false
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_user', '_pageReload'])), {}, {
    onSelectCustomer: function onSelectCustomer(id, name) {
      this.custom_name = name;
      this.SendMessage.fk_t_customer_id = id;
    },
    ProductClick: function ProductClick(e) {},
    AddressClick: function AddressClick(e) {
      console.log(e);
      this.SendMessage.gpsAddr = e.gps_addr;
      this.SendMessage.detailAddr = e.detail_addr;
      console.log(this.SendMessage);
    },
    dispatchClick: function dispatchClick(e) {
      this.SendMessage.serviceGroupId = e.id;
      this.SendMessage.serviceGroupName = e.name;
      this.SendMessage.revised_addr = e.revised_addr;
      this.SendMessage.revised_linkman = e.revised_linkman;
      this.SendMessage.revised_linkman_phone = e.revised_linkman_phone;
    },
    replaceMultiImg: function replaceMultiImg(urls) {
      if (!urls) return '';
      var urlArr = urls.split(',');
      return urlArr[0];
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var valid, data, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.SendMessage.customerPro.length) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this.$vux.toast.text(i18n.tc("220")));
              case 2:
                if (_this.SendMessage.gpsAddr) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this.$vux.toast.text(i18n.tc("221")));
              case 4:
                if (_this.SendMessage.serviceGroupId) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", _this.$vux.toast.text(i18n.tc("222")));
              case 6:
                _context.next = 8;
                return _this.$refs.customFormList.formValidate();
              case 8:
                valid = _context.sent;
                if (valid) {
                  _context.next = 11;
                  break;
                }
                return _context.abrupt("return");
              case 11:
                _this.btnLoading = true;
                data = _objectSpread(_objectSpread({}, _this.SendMessage), {}, {
                  listField: _this.fieldData
                });
                _context.next = 15;
                return sendrevisedordersave(data);
              case 15:
                res = _context.sent;
                if (res.success) {
                  _this.$vux.toast.text(i18n.tc("223"));
                  if (res.data) {
                    _this.$router.push({
                      name: 'RepairRecordDetail',
                      query: {
                        orderId: res.data
                      }
                    });
                  }
                } else {
                  _this.$vux.toast.text(res.message);
                }
                setTimeout(function () {
                  _this.btnLoading = false;
                }, 100);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    init: function init() {
      var _this2 = this;
      getSendRevisedOrderSendBaseInfo().then(function (res) {
        if (res.success) {
          _this2.customerList = res.data.customer_list || [];
          if (_this2.customerList.length) {
            _this2.custom_name = _this2.customerList[0].name;
            _this2.SendMessage.fk_t_customer_id = _this2.customerList[0].fk_t_customer_id;
          }
        }
      });
      getV2SendRevisedOrderTmplFields().then(function (res) {
        if (res.success) {
          _this2.fieldList = res.data.list || [];
        }
      });
    }
  }),
  // 初始化默认属性
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return apisystemsettingByCode({
                code: 40017
              }).then(function (res) {
                if (res.success) {
                  _this3.isShowCustomerInput = Number(res.data.value);
                }
              });
            case 2:
              _this3.init();
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};